module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/tech-talks-presentation/tech-talks-presentation.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/tech-talks-presentation/tech-talks-presentation.component.css
// module chunks = main